export const handleChangeDataModalEditEmail = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_EDIT_EMAIL', name, value
});